import { TDefineAssetTagsProps } from '@/shared/features/tags/hooks/use-define-asset-tags/use-define-asset-tags.types';
import { useDefineAssetTagsMutation } from '@/shared/redux/api/assets/tags/tags-api';

export const useDefineAssetTags = () => {
  const [_defineAssetTags] = useDefineAssetTagsMutation();

  return async ({ tags, ...asset }: TDefineAssetTagsProps) => {
    await _defineAssetTags({
      ...asset,
      input: tags.map((sourceId) => ({ sourceId })),
    }).unwrap();
  };
};
